
export default class CustomFunctions {
  /**
   * 初期化
   * @param options
   */
  constructor(options) {
    this.options = $.extend(options);
    this.init();
  }

  /**
   * 実行する
   */
  init() {
    this.searchFormModal();
    this.contactFormLink();
    this.formErrorAutoScroll();
  }

  /**
   * カスタム関数
   */

  // headerのフォーム
  searchFormModal() {
    const triggerbtnName = ".js-header-searchform-open";
    const contentName = ".js-header-searchform-content";
    // const closebtnName = ".js-header-searchform-close";
    const $triggerbtn = $(triggerbtnName);
    const $content = $(contentName);
    // const $closebtn = $(closebtnName);

    $triggerbtn.click(function (e) {
      //トリガーボタンを押したときの動作
      if($("body").hasClass('is-search-modal-open')){
        $("body").removeClass("is-search-modal-open");
        $triggerbtn.removeClass("is-active");
      }else{
        $("body").addClass("is-search-modal-open");
        $triggerbtn.addClass("is-active");
      }
    });
    $(document).on('click', function(e) {
      //bodyに.is-search-modal-openがついているときに、
      //検索フォーム本体でもトリガーボタンでも無い要素が押されたら
      if(!$(e.target).closest(contentName).length && !$(e.target).closest(triggerbtnName).length){
        if($("body").hasClass('is-search-modal-open')){
          //bodyの.is-search-modal-openと、トリガーボタンの.is-activeを外す
          $("body").removeClass("is-search-modal-open");
          $triggerbtn.removeClass("is-active");
        }
      }
    });
  }

    // お問い合わせフォーム連携
  contactFormLink() {
    const contactButtons = document.querySelectorAll('[data-contact-type]');

    contactButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        // デフォルトのアンカー動作を一度停止
        e.preventDefault();

        const contactType = button.dataset.contactType;

        // お問い合わせセクションにスクロール
        const contactSection = document.querySelector('#contact');
        if (contactSection) {
          contactSection.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });

          // スクロール完了後にラジオボタンを選択
          setTimeout(() => {
            this.selectRadioButton(contactType);
          }, 800); // スクロール時間を考慮
        }
      });
    });

    // 通常のラジオボタンクリック時の処理も追加
    this.initRadioButtonStyle();
  }

  // ラジオボタンを選択してスタイルを適用
  selectRadioButton(contactType) {
    const radioButton = document.querySelector(`input[type="radio"][value="${contactType}"]`);
    if (radioButton) {
      // 全てのラジオボタンのlabelからis-checkedクラスを削除
      const allRadioLabels = document.querySelectorAll('input[name="お問い合わせ種別"]');
      allRadioLabels.forEach(radio => {
        const label = radio.closest('label');
        if (label) {
          label.classList.remove('is-checked');
        }
      });

      // 選択されたラジオボタンをチェック
      radioButton.checked = true;

      // changeイベントを発火
      const changeEvent = new Event('change', { bubbles: true });
      radioButton.dispatchEvent(changeEvent);

      // 対応するlabelにis-checkedクラスを追加
      const targetLabel = radioButton.closest('label');
      if (targetLabel) {
        targetLabel.classList.add('is-checked');
      }

      // フォーカスを当てる
      radioButton.focus();
    }
  }

  // ラジオボタンの通常クリック時のスタイル処理
  initRadioButtonStyle() {
    const radioButtons = document.querySelectorAll('input[name="お問い合わせ種別"]');

    radioButtons.forEach(radio => {
      radio.addEventListener('change', () => {
        // 全てのlabelからis-checkedクラスを削除
        radioButtons.forEach(r => {
          const label = r.closest('label');
          if (label) {
            label.classList.remove('is-checked');
          }
        });

        // 選択されたラジオボタンのlabelにis-checkedクラスを追加
        if (radio.checked) {
          const label = radio.closest('label');
          if (label) {
            label.classList.add('is-checked');
          }
        }
      });
    });
  }


  // フォームエラー時の自動スクロール
  formErrorAutoScroll() {
    document.addEventListener('DOMContentLoaded', () => {
      // エラーメッセージが存在するかチェック
      const hasIndividualErrors = document.querySelector('.c-error');
      const hasErrorBox = document.querySelector('.c-error-box');

      if (hasIndividualErrors || hasErrorBox) {
        // エラーが存在する場合、フォームセクションまでスクロール
        setTimeout(() => {
          const contactSection = document.querySelector('#contact');

          if (contactSection) {
            contactSection.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });

            // フォーカスをフォームの最初の入力フィールドに当てる
            setTimeout(() => {
              const firstInput = contactSection.querySelector('input[type="radio"], input[type="text"], input[type="email"], textarea');
              if (firstInput) {
                firstInput.focus();
              }
            }, 800);
          }
        }, 100);
      }
    });
  }

  // 複製して作業
  mycode() {

  }


}




